module.exports = __webpack_public_path__ + "static/img/r-1-1-icon.199e084.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-1/r-1-1-icon.png
// module id = VVcS
// module chunks = 0